<script>
export default {
	name: 'AppBanner',
};
</script>

<template>
	<section class="relative">
		<div class="max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-14">
			<div
				class="flex flex-col items-center justify-center text-center min-h-[62vh] lg:min-h-[66vh] py-10 lg:py-0"
			>
				<div class="max-w-2xl">
					<p
						class="font-mono-ui text-xs sm:text-sm tracking-[0.22em] uppercase text-accent mb-6"
					>
						Games &middot; Apps &middot; Experiments
					</p>
					<h1
						class="font-general-light text-5xl sm:text-7xl xl:text-8xl leading-[0.95] tracking-tight text-ink"
					>
						Hi, we are<br />
						<span class="font-general-semibold">Anrealm</span>
					</h1>
					<p
						class="font-general-regular mt-6 max-w-md mx-auto text-base sm:text-lg leading-relaxed text-ink-muted"
					>
						We build games and apps for mobile and desktop &mdash; and
						a fair share of curious things in between.
					</p>
					<div class="mt-9 flex flex-wrap justify-center gap-3 sm:gap-4">
						<router-link
							to="/projects"
							class="group font-mono-ui text-sm tracking-wide px-6 py-3 rounded-lg bg-accent text-ink font-medium hover:bg-accent-soft duration-300 flex items-center gap-2"
							aria-label="View projects"
						>
							View Projects
							<span
								class="transition-transform duration-300 group-hover:translate-x-1"
								>&rarr;</span
							>
						</router-link>
						<router-link
							to="/about"
							class="font-mono-ui text-sm tracking-wide px-6 py-3 rounded-lg border border-line text-ink hover:border-line-strong duration-300"
							aria-label="About Us"
						>
							About Us
						</router-link>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<style scoped></style>
